/** @jsxImportSource @emotion/react */
"use client";

import { HallowDataTestId } from "@tools/playwright/global";
import type { ReactNode } from "react";

import { useIsDesktopViewport } from "../../../hooks/useIsDesktopViewport";
import type { ButtonProps } from "../../_base/_core/Button/Button.emotion";
import { Button } from "../../_base/_core/Button/Button.emotion";

type AuthSubmitProps = {
  disabled: boolean;
  children: ReactNode;
} & ButtonProps;

export const AuthSubmitButton = ({
  disabled,
  children,
  className = "",
  ...props
}: AuthSubmitProps) => {
  const isDesktop = useIsDesktopViewport();
  return (
    <Button
      type="submit"
      disabled={disabled}
      size="l"
      isFullWidth={!isDesktop}
      className={className}
      data-testid={HallowDataTestId.AuthSubmitButton}
      {...props}
    >
      {children}
    </Button>
  );
};
